module.exports = __webpack_public_path__ + "static/img/chain-height.e4db5a6e.png";